/* eslint-disable complexity */
import {createSlice} from '@reduxjs/toolkit';

export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        modals: [
            {
                name: 'passwordModal',
                display: false
            },
            {
                name: 'countryModal',
                display: false
            }
        ]
    },
    reducers: {
        show: (state, actions) => {
            state.modals = state.modals.map((modal) => {
                if (actions && actions.payload && actions.payload.name) {
                    if (modal.name === actions.payload.name) {
                        const modalTemp = modal;

                        return {
                            ...modalTemp,
                            display: !modalTemp.display
                        };
                    }
                }
                return modal;
            });
        }
    }
});

export const {show} = modalSlice.actions;
export default modalSlice.reducer;
